<template>
  <div class="grid grid-cols-1 gap-5">
    <b-modal id="videoShareModal" title="Share" centered hide-footer>
      <div class="d-flex justify-content-around mb-8">
        <a
          rel="nofollow"
          :href="`https://facebook.com/share.php?u=${copy}`"
          target="_black"
        >
          <img
            class="w-10 h-10 cursor-pointer"
            src="@/assets/icons/facebook.svg"
            alt=""
          />
        </a>
        <a
          :href="`https://linkedin.com/sharing/share-offsite/?url=${copy}`"
          target="_black"
        >
          <img
            class="w-10 h-10 cursor-pointer"
            src="@/assets/icons/Linkedin.svg"
          />
        </a>
        <a :href="`mailto:?body=${copy}`" target="_black">
          <img
            class="w-10 h-10 cursor-pointer"
            src="@/assets/icons/Mail.svg"
            alt=""
          />
        </a>
        <a :href="`https://api.whatsapp.com/send?text=${copy}`" target="_black">
          <img
            class="w-10 h-10 cursor-pointer"
            src="@/assets/icons/Whatsapp.svg"
            alt=""
          />
        </a>
        <a
          :href="`https://twitter.com/share?text=google&url=${copy}`"
          target="_black"
        >
          <img
            class="w-10 h-10 cursor-pointer"
            src="@/assets/icons/Twitter.svg"
            alt=""
          />
        </a>
      </div>

      <!-- <div class="container" ref="modalBody">
        <input type="text" v-model="message" />
        <button type="button" @click="doCopy(message)">Copy!</button>
      </div> -->
      <b-input-group size="md" class="mb-2">
        <b-form-input
          type="text"
          :class="{ inputstyle: applystyle }"
          v-model="copy"
        ></b-form-input>
        <b-input-group-prepend
          ref="videoShareModalBody"
          type="button"
          is-text
          class="cursor-pointer textstyle"
          @click="doCopy(copy)"
        >
          COPY
        </b-input-group-prepend>
      </b-input-group>
    </b-modal>
    <div v-if="shareWork && shareWork.result && shareWork.result.length > 0">
      <div v-for="(item, index) in shareWork.result" :key="`${item}+${index}`">
        <video
          width="400"
          v-if="item.video"
          controls
          class="w-full h-96 object-scale-down"
        >
          <source :src="$imageURL + '/' + item.video" type="video/mp4" />
        </video>
        <div class="flex justify-between mt-4">
          <div class="">
            <!-- <img :src="item.pimg" alt="" class="w-8 h-8 rounded-full" /> -->
            <!-- <img
            v-if="item.createdByUser.length"
            :src="item.createdByUser[0].userImage"
            class="w-8 h-8 rounded-full"
          />
          <img
            v-else
            src="@/views/userProfile/UserProfile/av1.jpg"
            class="w-8 h-8 rounded-full"
          /> -->
            <div>
              <h2>{{ item.firstName + " " + (item.lastName || "") }}</h2>
              <div class="fsize12" v-html="item.message"></div>
              <!-- {{ item.message.replace(/<\/?[^>]+>/gi, "") }} -->
              <!-- <div></div> -->
            </div>
          </div>
          <div class="flex items-center gap-2">
            <div class="bg-primary h-30px px-5 py-1 rounded-full">
              <div
                class="flex gap-2 cursor-pointer"
                @click="updateLike(item._id)"
              >
                <div>
                  <b-icon
                    v-if="renderlike(item.likedBy)"
                    icon="hand-thumbs-up-fill"
                    font-scale="1.5"
                    class="text-white"
                  />
                  <b-icon
                    v-else
                    icon="hand-thumbs-up"
                    font-scale="1.5"
                    class="text-white"
                  />
                </div>
                <p class="text-white">
                  {{ item.likeCount ? item.likeCount : 0 }}
                </p>
              </div>
            </div>
            <img
              v-b-modal.videoShareModal
              @click="setLink(url)"
              src="../../../../assets/images/share.png"
              alt="ShareIcon"
              class="h-5 w-5 cursor-pointer"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="flex items-center justify-center gap-2">
        <p class="text-center">No Video Available</p>
      </div>
    </div>
  </div>
</template>

<script>
import { BIcon, BIconHandThumbsUpFill, BIconHandThumbsUp } from "bootstrap-vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      videos: [
        // {
        //   image: require("../../../../assets/images/Product/Care Assitance.jpg"),
        //   pimg: require("../../../../assets/images/Product/Care Assitance.jpg"),
        //   title: "Diane's",
        //   post: "Assistance Manager",
        // },
        // {
        //   image: require("../../../../assets/images/Product/Care Assitance.jpg"),
        //   pimg: require("../../../../assets/images/Product/Care Assitance.jpg"),
        //   title: "Diane's",
        //   post: "Assistance Manager",
        // },
        // {
        //   image: require("../../../../assets/images/Product/Care Assitance.jpg"),
        //   pimg: require("../../../../assets/images/Product/Care Assitance.jpg"),
        //   title: "Diane's",
        //   post: "Assistance Manager",
        // },
        // {
        //   image: require("../../../../assets/images/Product/Care Assitance.jpg"),
        //   pimg: require("../../../../assets/images/Product/Care Assitance.jpg"),
        //   title: "Diane's",
        //   post: "Assistance Manager",
        // },
        // {
        //   image: require("../../../../assets/images/Product/Care Assitance.jpg"),
        //   pimg: require("../../../../assets/images/Product/Care Assitance.jpg"),
        //   title: "Diane's",
        //   post: "Assistance Manager",
        // },
        // {
        //   image: require("../../../../assets/images/Product/Care Assitance.jpg"),
        //   pimg: require("../../../../assets/images/Product/Care Assitance.jpg"),
        //   title: "Diane's",
        //   post: "Assistance Manager",
        // },
        // {
        //   image: require("../../../../assets/images/Product/Care Assitance.jpg"),
        //   pimg: require("../../../../assets/images/Product/Care Assitance.jpg"),
        //   title: "Diane's",
        //   post: "Assistance Manager",
        // },
      ],
      copy: "",
      applystyle: false,
    };
  },
  components: {
    BIcon,
    BIconHandThumbsUpFill,
    BIconHandThumbsUp,
  },
  methods: {
    // getShareWorks() {
    //   this.$emit("getShareWorks", "Poetry");
    // },
    setLink(link) {
      this.copy = link;
    },

    doCopy(copy) {
      this.$copyText(copy, this.$refs.videoShareModalBody);
      this.applystyle = true;
      // swal.fire({ title: "", icons: "success" });
      this.$swal.fire({
        text: "Link copied to clipboard",
        confirmButtonColor: "#830c81",
        showCancelButton: false,
        timer: 2000,
      });
    },
    handleRedirect(name) {
      this.$router.push({ name: name });
      this.$swal.fire({
        title: "",
        text: "Please login to access this content",
        icon: "warning",
        confirmButtonColor: "#830c81",
        showCancelButton: false,
      });
    },
    isLogedIn() {
      if (sessionStorage.getItem("token")) {
        return true;
      } else {
        this.handleRedirect("signin");
        return false;
      }
    },
    renderlike(likedBy) {
      if (likedBy && this.user._id) {
        if (likedBy.includes(this.user._id)) {
          return true;
        } else {
          return false;
        }
      }
      return false;
    },
    async updateLike(shareWorkId) {
      if (!this.isLogedIn()) {
        return;
      }

      let payload = {
        shareWorkId: shareWorkId,
      };
      try {
        let data = await this.$store.dispatch("hoc/setLike", payload);
        if (data.code === 200) {
          await this.getVideo();
        }
        // if (data.code === 401) {
        //   this.handleRedirect("signin");
        // }
      } catch (error) {
        console.log(error);
      }
    },
    async getVideo() {
      let payload = {
        art: "Video",
        limit: 100,
        offset: 0,
        status: "Approved",
      };
      try {
        await this.$store.dispatch("hoc/getSharework", payload);
      } catch (error) {
        console.log(error);
      }
    },
  },
  computed: {
    ...mapState("hoc", { shareWork: "shareWork" }),
    ...mapState("auth", { user: "user" }),
    url() {
      return window.location.href;
    },
  },
};
</script>

<style></style>
